var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKLogoBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13815_61239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 0H10.7927C7.92922 0 5.60742 2.43301 5.60742 5.43369V8H8.81536C11.6789 8 14.0007 5.56699 14.0007 2.56631V0Z",
    fill: "#262B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81536 8H5.60742V10.5663C5.60742 13.567 7.92922 16 10.7927 16H14.0007V13.4337C14.0007 10.433 11.6789 8 8.81536 8Z",
    fill: "#262B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60415 16H5.18531C2.32179 16 0 13.567 0 10.5663V0H0.41884C3.28236 0 5.60415 2.43301 5.60415 5.43369V16Z",
    fill: "#262B3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13815_61239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKLogoBlack);
export default __webpack_public_path__ + "static/media/KLogoBlack.d06e40a83506522798c9a6b4926d3dab.svg";
export { ForwardRef as ReactComponent };